import React from 'react';
import {
  ContainerDropZone,
  DropZone,
  DropZoneContent,
  DropZoneGeneral,
  Container,
  LogDetailsItem,
  SubTitle,
  Title,
} from './styles';
import FileDropzone from '../../components/ImportCSV/FileDropzone';
import FileList from '../../components/ImportCSV/FileList';
import Permission from '../../components/Permission';
import MetaTitle from '../../components/MetaTitle';
import convertDate from '../../utils/convertDate';
import useFetch from '../../hooks/useFetch';
import Modal from '../../components/Modal';
import Table from '../../components/Table';
import api from '../../services/api';
import fileSize from 'filesize';
import { Animation, Button, Status } from '../../assets/global/globalStyles';
import { fetchLogOrders } from '../../store/logOrders';
import { AddOutlined } from '@mui/icons-material';
import { getPopup } from '../../store/popup';
import { useDispatch } from 'react-redux';
import { uniqueId } from 'lodash-es';
import USER_GROUPS from '../../global/variables/userGroups';
import USER_ROLES from '../../global/variables/userRoles';

export default function UploadOrders() {
  const [openModalUpload, setOpenModalUpload] = React.useState(false);
  const [openModalDetails, setOpenModalDetails] = React.useState(false);
  const [dataDetails, setDataDetails] = React.useState({});
  const [files, setFiles] = React.useState([]);
  const { data: logOrders } = useFetch(
    fetchLogOrders({
      url: '/upload/log-arquivo',
      method: 'GET',
    }),
    'logOrders',
  );

  const dataUpdateObject = React.useMemo(
    () =>
      logOrders.map((item) => ({
        ...item,
        dataUpload: convertDate(item.dataUpload),
        _: item.lineQuantityError > 0 ? 'Processado com erro' : 'Processado',
      })),
    [logOrders],
  );

  const showModalUpload = () => setOpenModalUpload(!openModalUpload);
  const showModalDetail = () => {
    setOpenModalDetails(!openModalDetails);
    setDataDetails({});
  };
  const dispatch = useDispatch();

  const handleUpload = (data) => {
    const uploadedFiles = data.map((file) => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: fileSize(file.size),
      preview: URL.createObjectURL(file),
      progress: 0,
      uploaded: false,
      error: false,
      url: null,
    }));
    setFiles([...files, ...uploadedFiles]);
  };

  const processUpload = (uploadedFile) => {
    if (uploadedFile.file.size > 3145728) {
      dispatch(
        getPopup(`Arquivo maior do que 2Mb. ${uploadedFile.name}`, 'danger'),
      );
    }

    if (!uploadedFile.uploaded && uploadedFile.file.size < 3145728) {
      const data = new FormData();
      data.append('file', uploadedFile.file, uploadedFile.name);
      api
        .post('/upload/csv', data)
        .then((e) => {
          dispatch(
            getPopup({
              message: "Ação realizada com sucesso",
              type: 'success',
            }),
          );
          showModalUpload();
        })
        .catch((err) => {
          dispatch(
            getPopup({
              message: err?.response?.data?.message,
              type: 'danger',
            }),
          );
        });
    }
  };

  const handleSubmit = async () => {
    files.forEach(processUpload);
    setFiles([]);
  };

  const handleDelete = async (id) => {
    setFiles((prev) => prev.filter((file) => file.id !== id));
  };

  return (
    <>
      <Animation>
        <MetaTitle title="Pedidos" />
        <Permission
          roles={[USER_ROLES.Administrador, USER_ROLES.Leitor]}
          groups={[USER_GROUPS.DHL]}
          component={() => (
            <DropZoneGeneral>
              <DropZoneContent onClick={showModalUpload}>
                <DropZone>
                  <p>Adicione os pedidos</p>
                  <AddOutlined
                    style={{ width: '25px', height: '25px', color: '#f00' }}
                  />
                  <p>
                    <strong>Observação: </strong>Você só pode importar até 3MB
                    por arquivo.
                  </p>
                </DropZone>
              </DropZoneContent>
            </DropZoneGeneral>
          )}
        />
        <Table
          data={dataUpdateObject}
          title="Status de Pedidos"
          keyStorage="logorders_filter"
          columns={[
            'fileName',
            'lineQuantityProcessed',
            'lineQuantityError',
            'dataUpload',
          ]}
          columnNames={[
            'Nome do arquivo',
            'Linhas Processadas',
            'Linhas Errados',
            'Data do upload',
            'Status',
          ]}
          columnButtons={[
            ({ lineQuantityError }) => (
              <Status typeName={lineQuantityError > 0 ? 'danger' : 'success'}>
                {lineQuantityError > 0 ? 'Processado com erro' : 'Processado'}
              </Status>
            ),
            (data) => (
              <Button
                onClick={() => {
                  setDataDetails(data);
                  setOpenModalDetails(!openModalDetails);
                }}
                typeName="welcome"
              >
                Detalhes
              </Button>
            ),
          ]}
        />
      </Animation>
      <Modal open={openModalUpload} openModal={showModalUpload}>
        <ContainerDropZone>
          <FileDropzone onUpload={handleUpload} />
          {!!files.length && (
            <FileList
              files={files}
              onDelete={handleDelete}
              onSubmit={handleSubmit}
            />
          )}
        </ContainerDropZone>
      </Modal>
      <Modal open={openModalDetails} openModal={showModalDetail}>
        <Container>
          <Title>Detalhes do arquivo</Title>

          <LogDetailsItem>
            <SubTitle>Nome do arquivo</SubTitle>
            <p>{dataDetails?.fileName}</p>
          </LogDetailsItem>

          <LogDetailsItem>
            <SubTitle>Quantidade de linhas totais</SubTitle>
            <Status typeName="welcome">{dataDetails?.lineQuantity}</Status>
          </LogDetailsItem>

          <LogDetailsItem>
            <SubTitle>Quantidade de linhas processadas</SubTitle>
            <Status typeName="success">
              {dataDetails?.lineQuantityProcessed}
            </Status>
          </LogDetailsItem>

          <LogDetailsItem>
            <SubTitle>Quantidade de linhas com erros</SubTitle>
            <Status typeName="danger">{dataDetails?.lineQuantityError}</Status>
          </LogDetailsItem>

          <LogDetailsItem>
            <SubTitle>Data do upload</SubTitle>
            <p>
              {dataDetails?.dataUpload && convertDate(dataDetails?.dataUpload)}
            </p>
          </LogDetailsItem>

          <LogDetailsItem>
            <SubTitle>Erros encontrados</SubTitle>
            <p>
              {dataDetails?.lineWithError?.split('\r\n').map((data, i) => (
                <span key={i}>
                  {data.split(' -')[0]}
                  <br />
                  <b>{data.split(' -')[1]}</b>
                  <br />
                  <br />
                </span>
              ))}
            </p>
          </LogDetailsItem>
        </Container>
      </Modal>
    </>
  );
}
